import { createUseStyles } from "react-jss";
import { mediaQueries } from "../../../../common/constants";
export const EditRequestContainerStyle = createUseStyles((theme: any) => ({
    container: (props: any) => ({
        height: "auto",
        background: props.selectedKey === "0" ? theme.colors.editRequest.containerBackGround : "white",
        justifyContent: "space-between",
        marginTop: "15px",
    }),
    buttonReturnList: {
        fontSize: 23,
        cursor: "pointer",
        userSelect: "none",
    },
    disclaimer: {
        display: "flex",
        width: "100%",
        columnGap: 4,
        color: theme.colors.form.input.default,
        fontSize: theme.fonts.sizes.sm,
        alignContent: "center",
        "& span": {
            color: theme.colors.titles.danger.color,
            fontWeight: 600,
        },
        [mediaQueries.TABLET]: {
            display: "flex",
            justifyContent: "start",
        },
    },
    actionButtons: {
        padding: "17px 24px 0px 24px",
        display: "flex",
        gap: theme.gaps.buttons.default,
        justifyContent: "space-between",
        alignItems: "center",
        "& div:nth-child(1)": {
            width: "40%",
        },
        "& button": {
            minWidth: 110,
        },
        "& div:nth-child(2)": {
            display: "flex",
            gap: theme.gaps.buttons.default,
            width: "50%",
            justifyContent: "end",
        },
        [mediaQueries.TABLET]: {
            display: "flex",
            flexDirection: "column",
            "& div:nth-child(1)": {
                width: "100%",
            },

            "& div:nth-child(2)": {
                width: "100%",
                display: "flex",
                gap: theme.gaps.buttons.default,
            },
        },
    },
    actaButton:{
        width:100
    }
}));
